module.exports = __webpack_public_path__ + "img/h1.ead4dd96.png";